/**
 * @file
 */
export default {
    lostOfficialUser: '',
    isCheckedNotRelatedIssue: false,
    selectedQuestionCategory: 0,
    selectedQuestionType: 0,
    selectedQuestionTag: 0,
    selectedBugLevel: -1,
    hasInputDetail: false,
    issueFilterProcess: 'ALL',
    issueFilterTitle: '',
    issueToCheckData: {},
    canChangeProcess: false
};
